// convert array into text-label type
const filterArr = (arr, alias) => {
    let newArr = []
    arr.map(item => {
        newArr.push({ text: item[alias.text], value: item[alias.value] })
    })
    return newArr
}
const opt = {
	filterArr
}
export default opt